import React from 'react'

class SwitchingSpecial extends React.Component {
    render () {
        /* Define column round of 32 confrontations */
        let roundOf32Competitors = this.props.roundOf32Competitors.map((competitor, index) => {
            /* Change the color if competitor is fit */
            let localColor = ''
            if(!competitor.apto)
                localColor = 'red'

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if(index % 2 === 0)
                localBgColor = 'gainsboro'
            
            /* Change margin top/bottom to separate confrontations */
            let localMarginBottom = '1px'
            if(index % 2 !== 0)
                localMarginBottom = '7px'

            /* Change color to define who won */
            if(competitor.hasWon){
                //localBgColor = ''
                localColor = ''
            }
        
            return(
                <div
                    key={index}
                    className="switchingSubBlock01"
                    style={{ backgroundColor: localBgColor, color: localColor, marginBottom: localMarginBottom}}
                >
                    <div
                        style={{ display: 'block', width: '80%' }}
                        className='sharedTextIntoDiv'
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }} 
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                </div>
            )
        })

        /* Draw lines between round of 32 and round of 16  */
        let linesBetweenRoundOf32AndRoundOf16 = this.props.arrayForLines00.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '16.5625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '36.125px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '21.5625px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        let linesBetweenRoundOf32AndRoundOf1602 = this.props.arrayForLines00.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: (count === 9 ? '24.125px' : '34.125px'), borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '41.025px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        /* Define column one of round of 16 confrontations */
        let roundOf16Competitors = this.props.roundOf16Competitors.map((competitor, index) => {
            /* Change the color if competitor is fit */
            let localColor = ''
            if(!competitor.apto)
                localColor = 'red'

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if(index % 2 === 0)
                localBgColor = 'gainsboro'
            
            /* Margin top/bottom to separate confrontations */
            let localMarginTop = '17.0625px'
            let localMarginBottom = '41.0625px'

            /* Change color to define who won */
            if(competitor.hasWon){
                //localBgColor = ''
                localColor = ''
            }
        
            return(
                <div
                    key={index}
                    className="switchingSubBlock01"
                    style={{ backgroundColor: localBgColor, color: localColor, marginTop: localMarginTop, marginBottom: localMarginBottom}}
                >
                    <div
                        style={{ display: 'block', width: '80%' }}
                        className='sharedTextIntoDiv'
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }} 
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    
                </div>
            )
        })

        /* Draw lines between round of 16 and quarter finals  */
        let linesBetweenRoundOf16AndQuarterFinals = this.props.arrayForLines01.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: (count === 5 ? '24.125px' : '34.125px'), borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '75.1875px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '41.0625px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        let linesBetweenRoundOf16AndQuarterFinals02 = this.props.arrayForLines01.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: (count === 5 ? '65.25px' : '72.25px'), borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '79.25px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        /* Define column one of quarter finals confrontations */
        let quarterFinalsCompetitors = this.props.quarterFinalsCompetitors.map((competitor, index) => {
            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if(index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Change color to define who won */
            let localColor = ''
            if(competitor.hasWon){
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '55.6875px'
            if(index !== 0)
                localMarginTop = '116.875px'
            
            return(
                <div
                    key={index}
                    className="switchingSubBlock02"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        style={{ display: 'block', width: '80%' }}
                        className='sharedTextIntoDiv'
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }} 
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                </div>
            )
        })

        /* Draw lines between quarter finals and semi finals  */
        let linesBetweenQuarterAndSemiFinals01 = this.props.arrayForLines02.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '72.25px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '151.5px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '79.25px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        let linesBetweenQuarterAndSemiFinals02 = this.props.arrayForLines02.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '148.5px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '155.5px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        /* Define column one of semi finals confrontations */
        let semiFinalsCompetitors = this.props.semiFinalsCompetitors.map((competitor, index) => {
            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if(index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Change color to define who won */
            let localColor = ''
            if(competitor.hasWon){
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '130.9375px'
            if(index !== 0)
                localMarginTop = '269.875px'
        
            return(
                <div
                    key={index}
                    className="switchingSubBlock03"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, cursor: 'pointer', color: localColor }}
                >
                    <div
                        style={{ display: 'block', width: '80%' }}
                        className='sharedTextIntoDiv'
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }} 
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                </div>
            )
        })

        /* Draw lines between semi finals and final  */
        let linesBetweenSemiAndFinal01 = this.props.arrayForLines03.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '148.5px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '304px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '155px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        let linesBetweenSemiAndFinal02 = this.props.arrayForLines03.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '300.5px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '313px', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        /* Define column one of final confrontations */
        let finalCompetitors = this.props.finalCompetitors.map((competitor, index) => {
            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if(index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Change color to define who won */
            let localColor = ''
            if(competitor.hasWon){
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '283.9375px'
            if(index !== 0)
                localMarginTop = '580.4375px'

            return(
                <div
                    key={index}
                    className="switchingSubBlock04"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        style={{ display: 'block', width: '80%' }}
                        className='sharedTextIntoDiv'
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }} 
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                </div>
            )
        })

        /* Draw lines between final  */
        let linesBetweenFinal01 = this.props.arrayForLines04.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '300.5px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                    <div style={{ height: '613.5625px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        let linesBetweenFinal02 = this.props.arrayForLines04.map(count => {
            return(
                <div key={count} style={{ float: 'left', width: '100%' }}>
                    <div style={{ height: '607.28125px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                </div>
            )
        })

        return (
            <div>
                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                    {roundOf32Competitors}
                </div>

                <div className='switchingBetweenBlock'> {linesBetweenRoundOf32AndRoundOf16} </div>
                <div className='switchingBetweenBlock'> {linesBetweenRoundOf32AndRoundOf1602} </div>

                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                    {roundOf16Competitors}
                </div>

                <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals} </div>
                <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals02} </div>

                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                    {quarterFinalsCompetitors}
                </div>

                <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals01} </div>
                <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals02} </div>

                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                    {semiFinalsCompetitors}
                </div>

                <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal01} </div>
                <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal02} </div>

                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                    {finalCompetitors}
                </div>

                <div className='switchingBetweenBlock'> {linesBetweenFinal01} </div>
                <div className='switchingBetweenBlock'> {linesBetweenFinal02} </div>

                <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                    <div className="switchingSubBlock05">
                        <div
                            style={{ display: 'block', width: '80%' }}
                            className='sharedTextIntoDiv'
                        > &nbsp;{this.props.champion.nome}&nbsp;</div>
                        <div
                            className='sharedTextIntoDiv'
                            style={{ display: 'block', width: '80%', color: 'dimgray', float: 'left', fontStyle: 'italic', fontSize: 'xx-small' }} 
                        >&nbsp;{this.props.champion.equipe}&nbsp;</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SwitchingSpecial